<template>
  <v-card>
    <!-- <v-divider class="ma-0 mb-0" /> -->
    <v-card-text class="pa-0">
      <v-carousel
          v-model="page"
          hide-delimiters
          :show-arrows="false"
          width="100%"
          height="100%"
          touchless
      >
        <v-carousel-item :value="0">
          <v-container class="pa-0 py-2" fill-height fluid style="display: grid;">
            <v-row class="ma-0">
              <v-col class="py-1">
                <v-text-field
                    :value="filterSelection.documentNbr?.text"
                    :label="$t('label.documentNumber')"
                    ref="documentNbr"
                    @input="(v) => onFieldChange(v?.toUpperCase() ?? v, 'documentNbr', 'text', 'value')"
                    class="to-upper-text"
                    prepend-inner-icon="mdi-file-document-outline"
                    hide-details
                    clearable
                    dense
                />
              </v-col>
              <v-col class="py-1">
                <v-text-field
                    :value="filterSelection.billOfLading?.text"
                    :label="$t('label.billOfLading')"
                    ref="billOfLading"
                    @input="(v) => onFieldChange(v?.toUpperCase() ?? v, 'billOfLading', 'text', 'value')"
                    class="to-upper-text"
                    prepend-inner-icon="mdi-file-document-outline"
                    hide-details
                    clearable
                    dense
                />
              </v-col>
              <v-col class="py-1">
                <v-text-field
                    :value="filterSelection.equipment?.text"
                    :label="$t('label.equipment')"
                    ref="equipment"
                    @input="(v) => onFieldChange(v?.toUpperCase() ?? v, 'equipment', 'text', 'value')"
                    class="to-upper-text"
                    prepend-inner-icon="mdi-train-car-container"
                    hide-details
                    clearable
                    dense
                />
              </v-col>
              <v-col class="py-1">
                <v-select
                    :value="filterSelection.saleChannelIn"
                    :label="$t('label.saleChannel')"
                    ref="saleChannel"
                    :items="saleChannelFilterList"
                    @change="(v) => onFieldChange(v, 'saleChannelIn', 'value', 'text')"
                    return-object
                    prepend-inner-icon="mdi-cube-send"
                    class="text-caption"
                    :menu-props="menuProps"
                    hide-details
                    clearable
                    dense
                />
              </v-col>
            </v-row>

            <v-row class="ma-0">
              <v-col class="py-1">
                <CustomAutocomplete
                    ref="shipper"
                    :current="filterSelection.shipperId"
                    :value="'id'"
                    :text="'customerName'"
                    :label="$t('label.shipper')"
                    :icon="'mdi-account-arrow-right'"
                    :textClass="'text-caption'"
                    @select="(v) => onFieldChange(v, 'shipperId', 'value', 'text')"
                    @browse="(v) => browseCustomers(v, 'shipper')"
                />
              </v-col>
              <v-col class="py-1">
                <CustomAutocomplete
                    ref="consignee"
                    :current="filterSelection.consigneeId"
                    :value="'id'"
                    :text="'customerName'"
                    :label="$t('label.consignee')"
                    :icon="'mdi-account-arrow-left'"
                    :textClass="'text-caption'"
                    @select="(v) => onFieldChange(v, 'consigneeId', 'value', 'text')"
                    @browse="(v) => browseCustomers(v, 'consignee')"
                />
              </v-col>
              <v-col class="py-1">
                <NodoAutocomplete
                    :value="filterSelection.pol"
                    :label="$t('label.loadingNode')"
                    icon="mdi-upload"
                    ref="pol"
                    @change="(v) => onFieldChange(v, 'pol', 'locode', 'countryName')"
                />
              </v-col>
              <v-col class="py-1">
                <NodoAutocomplete
                    :value="filterSelection.pod"
                    :label="$t('label.dischargeNode')"
                    icon="mdi-download"
                    ref="pod"
                    @change="(v) => onFieldChange(v, 'pod', 'locode', 'countryName')"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0">
              <v-col class="py-1">
                <CustomAutocomplete
                    ref="carrier"
                    :current="filterSelection.carrier"
                    :value="'supplierId'"
                    :text="'supplierName'"
                    :label="$t('label.shippingLine')"
                    :icon="'mdi-account-settings'"
                    :textClass="'text-caption'"
                    @select="(v) => onFieldChange(v, 'carrier', 'value', 'text')"
                    @browse="(v) => browseSuppliers(v, 'carrier')"
                />
              </v-col>
              <v-col class="py-1">
                <v-text-field
                    :value="filterSelection.incoterms?.text"
                    :label="$t('label.freightTerms')"
                    ref="incoterms"
                    @input="(v) => onFieldChange(v?.toUpperCase() ?? v, 'incoterms', 'text', 'value')"
                    class="to-upper-text"
                    prepend-inner-icon="mdi-file-document-outline"
                    hide-details
                    clearable
                    dense
                />
              </v-col>

              <v-col class="py-1">
                <CustomAutocomplete
                    ref="client"
                    :current="filterSelection.clientId"
                    :value="'id'"
                    :text="'customerName'"
                    :label="$t('label.clientFm')"
                    :icon="'mdi-account'"
                    :textClass="'text-caption'"
                    @select="(v) => onFieldChange(v, 'clientId', 'value', 'text')"
                    @browse="(v) => browseCustomers(v, 'client')"
                />
              </v-col>
              <v-col class="py-1">
                <CustomAutocomplete
                    ref="secondClient"
                    :current="filterSelection.secondClientId"
                    :value="'id'"
                    :text="'customerName'"
                    :label="$t('label.clientTo')"
                    :icon="'mdi-account'"
                    :textClass="'text-caption'"
                    @select="(v) => onFieldChange(v, 'secondClientId', 'value', 'text')"
                    @browse="(v) => browseCustomers(v, 'secondClient')"
                />
              </v-col>
            </v-row>

            <ExtraFilters
                ref="extraFilters"
                :filterSelection="filterSelection"
                rowClass="ma-0"
                colClass="py-1"
                textClass="text-caption"
                :cols="12 / FIELDS_PER_ROW"
                @change="onFieldChange"
            >
              <template v-if="inlineActions" v-slot:actions>
                <v-btn x-small class="secondary pa-1" @click="resetAllFilters">
                  <v-icon x-small class="mr-1">mdi-filter-remove</v-icon>
                  <span>{{ $t('upper.resetFilter') }}</span>
                </v-btn>
                <v-btn x-small class="secondary pa-1 ml-2" @click="setFilter">
                  <v-icon x-small class="mr-1">mdi-magnify</v-icon>
                  <span>{{ $t('upper.search') }}</span>
                </v-btn>
              </template>
            </ExtraFilters>

          </v-container>
        </v-carousel-item>
        <v-carousel-item class="pa-3 pb-0" :value="1">
          <v-data-table
              :items="savedFilters"
              :items-per-page="8"
              hide-default-header
              :hide-default-footer="savedFilters.length ? false : true"
              class="filters-table"
              dense
          >
            <template slot="no-data">
              <div class="no-data">
                <v-icon color="warning" class="mr-1" size="20">
                  mdi-alert
                </v-icon>
                <span class="font-weight-medium warning--text">
                  {{ $t('label.noAvailableData') }}
                </span>
              </div>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <span>{{ item.value.nameFilter }}</span>
                </td>
                <td class="px-1 d-flex justify-end">
                  <div class="actions">
                    <v-icon
                        color="green"
                        class="mr-3"
                        @click="uploadFilter(item)"
                    >
                      mdi-upload
                    </v-icon>
                    <v-icon color="red" @click="deleteItem(item)">
                      mdi-delete
                    </v-icon>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-carousel-item>
      </v-carousel>
    </v-card-text>
    <!-- <v-divider class="ma-0 mt-0" /> -->
    <v-card-actions class="pa-2" v-if="page == 1 || !inlineActions">
      <template class="d-inline-flex" style="width: 100%;" v-if="page == 1">
        <v-btn icon x-small color="primary" v-if="page == 1" @click="page = 0">
          <v-icon size="25">mdi-arrow-left-circle</v-icon>
        </v-btn>
      </template>
      <template class="d-inline-flex" style="width: 100%;" v-if="page == 0">
        <v-menu
            v-if="canSaveFilters"
            v-model="saveFilterMenu"
            top
            offset-y
            transition="scale-transition"
            :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn
                x-small
                class="secondary pa-1"
                v-on="on"
                @click="focusFilterName"
            >
              <v-icon x-small class="mr-1">mdi-filter-plus</v-icon>
              <span>{{ $t('upper.saveFilter') }}</span>
            </v-btn>
          </template>
          <v-list class="pa-0" width="16rem" v-click-outside="clearFilterName">
            <v-list-item class="py-1 px-2">
              <v-list-item-title>
                <v-text-field
                    v-model="filterName"
                    :label="$t('label.filterName')"
                    ref="filterName"
                />
              </v-list-item-title>
              <v-list-item-icon class="ml-1">
                <v-icon color="success" @click="saveFilter">
                  mdi-content-save
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn x-small class="secondary pa-1 ml-2" @click="loadSavedFilters" v-if="canSaveFilters">
          <v-icon x-small class="mr-1">mdi-account-filter</v-icon>
          <span>{{ $t('upper.loadSavedFilters') }}</span>
        </v-btn>
        <v-spacer/>
        <v-btn x-small class="secondary pa-1" @click="resetAllFilters">
          <v-icon x-small class="mr-1">mdi-filter-remove</v-icon>
          <span>{{ $t('upper.resetFilter') }}</span>
        </v-btn>
        <v-btn x-small class="secondary pa-1" @click="setFilter">
          <v-icon x-small class="mr-1">mdi-magnify</v-icon>
          <span>{{ $t('upper.search') }}</span>
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Filters from '@/mixins/Filters'

const FIELDS_PER_ROW = 4

export default {
  name: 'FiltersCard',
  mixins: [Filters],
  data() {
    return {
      FIELDS_PER_ROW,
    }
  },
  computed: {
    ...mapGetters('account', ['enabledExtraFilters']),
    // reset/search move into the free space of the extra filters row
    inlineActions() {
      return !this.canSaveFilters && this.enabledExtraFilters.length % FIELDS_PER_ROW !== 0
    },
  },
  created() {
    this.findAllSapUsers()
  },
}
</script>

<style scoped>
.filters-table {
  width: 100%;
  height: 100%;
}

.filters-table::v-deep .v-data-footer {
  justify-content: right;
}

.filters-table::v-deep .v-data-footer__select {
  display: none;
}

.filters-table::v-deep .v-input--selection-controls__ripple {
  height: 0 !important;
}

.filters-table::v-deep tr {
  display: flex;
}

.filters-table::v-deep td {
  display: grid;
  align-items: center !important;
  padding: 0.3rem !important;
  width: -webkit-fill-available;
}

.actions {
  display: flex;
  align-content: center;
  max-width: max-content;
}

.no-data {
  justify-self: center !important;
}

.to-upper-text::v-deep input {
  text-transform: uppercase !important;
}
/*.row {
  border: solid 1px red;
}
.col {
  border: solid 1px orange;
}*/
</style>
